"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
    return _react2.default.createElement(
        "svg",
        { width: "8", height: "8", viewBox: "0 0 8 8", className: "Icon close-x", xmlns: "http://www.w3.org/2000/svg" },
        _react2.default.createElement(
            "g",
            { stroke: "#929292", fill: "none", strokeWidth: "1.2" },
            _react2.default.createElement("path", { d: "M0 0l8 8M8 0L0 8" })
        )
    );
}; /*eslint-disable */


//////////////////
// WEBPACK FOOTER
// ./src/client/components/icons/small/jsx/close-x.js
// module id = 1857
// module chunks = 0